import { useCallback, useState } from 'react';
import {
  getSimplifiedUndercutMode,
  SimplifiedUndercutMode,
} from 'src/utils/autoPricingUtils';
import { AutoPricingUndercutMode } from 'src/WebApiController';

export const useSimplifiedUndercutMode = (
  undercutMode: AutoPricingUndercutMode | null,
  undercutReferenceListingPosition: number | null,
  setUndercutModeValues: (
    undercutModeNew: AutoPricingUndercutMode | null,
    undercutReferenceListingPositionNew: number | null
  ) => void
) => {
  const [simplifiedUndercutMode, setSimplifiedUndercutMode] =
    useState<SimplifiedUndercutMode | null>(
      getSimplifiedUndercutMode(undercutMode, undercutReferenceListingPosition)
    );

  useState<SimplifiedUndercutMode | null>(null);

  const onSimplifiedUndercutModeChange = useCallback(
    (simplifiedUndercutModeNew: SimplifiedUndercutMode | null) => {
      setSimplifiedUndercutMode(simplifiedUndercutModeNew ?? null);

      if (!simplifiedUndercutModeNew) {
        setUndercutModeValues(null, null);
      } else {
        const newUndercutReferenceListingPosition =
          undercutReferenceListingPosition ?? 2;

        switch (simplifiedUndercutModeNew) {
          case SimplifiedUndercutMode.CheapestListing:
            setUndercutModeValues(AutoPricingUndercutMode.Simple, null);
            break;
          case SimplifiedUndercutMode.NthCheapestListing:
            setUndercutModeValues(
              AutoPricingUndercutMode.Simple,
              newUndercutReferenceListingPosition
            );
            break;
          case SimplifiedUndercutMode.AvgOfNthCheapestListings:
            setUndercutModeValues(
              AutoPricingUndercutMode.AverageOfCheapestListings,
              newUndercutReferenceListingPosition
            );
            break;
        }
      }
    },
    [setUndercutModeValues, undercutReferenceListingPosition]
  );

  return {
    simplifiedUndercutMode,
    onSimplifiedUndercutModeChange,
  };
};
